CheckoutV2.PaymentV2 = function(checkout) {
    var payment = this;

    // Modals
    this.addNewCardModal = new CheckoutV2.PaymentV2.ModalAddCard(checkout);
    this.changeCardModal = new CheckoutV2.PaymentV2.ModalChangeCard(checkout);
    this.changeAccountModal = new CheckoutV2.PaymentV2.ModalChangeAccount(checkout);
    this.splitPaymentModal = new CheckoutV2.PaymentV2.ModalSplitPayment(checkout);
    this.giftCardModal = new CheckoutV2.PaymentV2.ModalGiftCard(checkout);

    // Models instance
    this.models = new CheckoutV2.PaymentV2.Models(checkout);

    // Radio button payment methods
    this.paymentMethods = [
        {'name' : 'creditcard', 'label' : 'Credit Card', 'class': CheckoutV2.PaymentV2.CreditCard},
        {'name' : 'paypal', 'label' : 'PayPal', 'class': CheckoutV2.PaymentV2.PayPal},
        {'name' : 'btpaypal', 'label' : 'PayPal', 'class': CheckoutV2.PaymentV2.BraintreePayPal},
        {'name' : 'storedbtpaypal', 'label' : 'PayPal', 'class': CheckoutV2.PaymentV2.BraintreePayPal},
        {'name' : 'paypalrequest', 'label':'PayPal Request', 'class': CheckoutV2.PaymentV2.PayPalRequest},
        {'name' : 'wiretransfer', 'label':'Wire Transfer', 'class': CheckoutV2.PaymentV2.WireTransfer},
        {'name' : 'priorauth', 'label':'Prior Authorization', 'class': CheckoutV2.PaymentV2.PriorAuth},
        {'name' : 'affirm', 'label':'Affirm', 'class': CheckoutV2.PaymentV2.Affirm},
        {'name' : 'onaccount', 'label':'On Account', 'class': CheckoutV2.PaymentV2.OnAccount}
    ];

    // Container for the payment method radios
    this.$container = $('.js-payment.js-payment-method');

    this.$loadingOverlay = $( ".js-payment-loading-overlay" );
    this.$loadingMsg = payment.$loadingOverlay.find( ".msg-text" );

    // Container for the no payment methods selected text
    this.$noPaymentMethodContainer = $('.js-payment.js-no-payment-method');

    // Container for the error message alert
    this.$errorContainer = $('#payment-error');

    // In Store payment methods
    this.balances = new CheckoutV2.PaymentV2.Balances(checkout);
    // In Store payments container for rewards and in store credits
    this.$balancesContainer = $('.js-available-balances');

    // List of the currently active payment methods. Will be multiple for split payments
    this.activeMethods = [];

    // List of the currently active balance methods (in store credit, rewards, gift cards)
    this.activeBalances = [];

    // List of cards added through the addCard modal.
    // Credit cards that are added are treated like stored payments but with a different method name
    this._addedCards = [];

    // The current payment method active
    this.currentPaymentMethod = null;

    // Flag used to determine if the payment method has been previously set
    this.isDirty = false;

    // Flag used to determine if the payment module is valid (payment method is valid)
    this._isValid = false;

    // Flag used to know if balances cover the order
    this._isNoPaymentRequired = false;

    // Flag used to signal that a totals update was done as a result of a payment method removal
    this.isMethodRemoval = false;

    // Flag used to determine if we have selected a third party payment
    this.hasThirdPartyPayment = false;

    // Third party payment type. 'affirm' or 'paypal'
    this.thirdPartyPaymentType = null;

    this.by = false;

    this.btID = 1;

    this._init = function() {
        // Events
        checkout.registerStepChangedListener(payment._onStepChanged);
        checkout.cart.totals.registerTotalChangedListener(payment.onUpdateTotals);

        var isPayPalPayment = function( p ) {
            return p.method.indexOf( "storedbtpaypal" ) == 0;
        };
        var storedPayments = checkout.session.get( "storedPayments" ) || [];
        var storedPayPalPayments = storedPayments.filter( isPayPalPayment );
        if ( storedPayPalPayments.length == 0 ) {
            payment.$container.find( ".js-paypal-stored" ).hide();
        }

        this._listen();
    };

    this._listen = function() {
        // Listener for clicking on the card instead of the radio button
        // Does the same thing as clicking on the radio button
        payment.$container.find('.payment-methods>.card').on('click', function(e) {
            // Let the event fall through to the change handler if this is the radio button
            var $element = $(e.target);
            if($element.is('input[name="payment-method"]')) {
                return;
            }

            // Find the radio button to get a method name
            var $radio = $(this).find('input[name="payment-method"]');
            if($radio.is(':checked')) {
                return false;
            }

            // trigger the method switch
            payment.setMethodByName($radio.val());

            // scroll to keep selected payment in sight on the page
            // btpaypal will handle scrolling separately as it is asynchrounsly rendering UI elements
            if ($radio.val() != 'btpaypal') {
                var $payment = $element.closest('.card');
                var offset = $payment.offset().top;
                var banner = $('body .js-skinny-header').css('position') == 'sticky' ? $('body .js-skinny-header').height() : 0;
                // scroll if the element does not fit on screen after selection
                if ( (offset + banner < $(window).scrollTop()) || (offset + $payment.height() > $(window).height() - banner) ) {                    
                    $('html, body').animate(
                        {
                          scrollTop: offset - banner,
                        },
                        250,
                        'linear'
                    );
                }
            }
        });

        // Listener for the payment method radio change
        payment.$container.find('input[name="payment-method"]').on('change', function(e) {
            // Hide all methods.
            $(this).parents('.payment-methods').find('.collapse').removeClass('show');

            var methodName = $(this).val();

            // If we have multiple active methods, its a split payment scenario.
            // The removal of all existing methods should only take place if a method was changed
            // and we weren't coming from having split payments on a new card.
            // Split payments on new cards works by switching payment methods to stored cards
            // in order to handle the split payment work.
            if(payment.activeMethods.length === 1 || methodName !== 'creditcard') {
                var oldMethods = payment.activeMethods;
                payment.activeMethods = [];
                payment._onPaymentMethodsRemoved(oldMethods);
            }

            // Calls the destroy function on the current payment method if it exists
            if(payment.currentPaymentMethod){
                if(typeof payment.currentPaymentMethod.destroy === 'function') {
                    payment.currentPaymentMethod.destroy();
                }
            }

            var method = payment._getMethodFromMethodName(methodName);
            payment.currentPaymentMethod = new method['class'](checkout, $(this).parents('.card'));
            payment.isDirty = true;
        });

        //Listener for the close click on the error container
        payment.$errorContainer.find('button').on('click', function(e){
            e.preventDefault();
            payment.hideErrors();
        });

        payment.$loadingOverlay.on(
            "animationend webkitAnimationEnd MSAnimationEnd",
            function( e ) {
                if( payment.$loadingOverlay.hasClass( "fade-out" ) ) {
                    payment.$loadingOverlay.hide();
                }
            }
        );
    };

    // Clears the third party payment state variables
    this._clearThirdPartyPaymentActive = function(){
        payment.hasThirdPartyPayment = false;
        payment.thirdPartyPaymentType = null;
    };

    // Returns a payment method entry for a given name
    this._getMethodFromMethodName = function(methodName) {
        var found = payment.paymentMethods.filter(function(method) {
            return method.name === methodName;
        });
        return found[0];
    };

    // Called when a payment method is removed.
    // The cart totals need to be updated to reflect any difference in payment methods changing like fees being removed
    this._onPaymentMethodsRemoved = function(methods) {
        // Unset the third party payment flags. This will be set by a method if needed when instanced
        payment._clearThirdPartyPaymentActive();
        if(methods.length) {
            payment.isMethodRemoval = true;
            checkout.cart.totals.buildPaymentMethodsV2([], payment.activeBalances);
        }
    };

    // Event registered for when the step changes
    this._onStepChanged = function() {
        if(payment.currentPaymentMethod){
            if(checkout.currentStepName() === 'payment') {
                // If you get an error here, you need to implement this on your method
                payment.currentPaymentMethod.setNextStepButtonHtml();
            }
        }
    };

    // Called when totals are updated
    this.onUpdateTotals = function(oldTotals) {
        var oldCartTotal = __fixDecimals(oldTotals.total);
        var oldCartRemaining = __fixDecimals(oldTotals.remaining);
        var currentCartTotal = __fixDecimals(checkout.cart.totals.values.total);
        var currentCartRemaining = __fixDecimals(checkout.cart.totals.values.remaining);
        var fees = 0;
        Object.keys(checkout.cart.totals.values.fees).forEach(function(key) {
            fees += checkout.cart.totals.values.fees[key];
        });

        // It's a little dirty but no other good way to get this done quickly.
        // We need to deal with the session being out of sync with what cart totals and balances are going to do when
        // coming back from a redirect. So the state of balances needs to be restored when
        // the current cart total is non zero
        var sessionBalances = checkout.session.get('totals.balances');
        var activeBalances = payment.balances.getActiveBalances();
        var addedBalance = false;

        if(currentCartTotal > 0 && checkout.cameFromRedirect){
            Object.keys(sessionBalances).forEach(function(key) {
                var creditExists = false;
                if(key.indexOf('Store Credit') !== -1) {
                    activeBalances.forEach(function(item) {
                        if(item.type === 'instore') {
                            creditExists = true;
                        }
                    });
                    if(!creditExists) {
                        addedBalance = true;
                        payment.balances.$inStore.find('input').attr('checked', 'checked');
                        payment.balances._addActiveBalance('instore', __fixDecimals(sessionBalances[key]));
                    }
                }
                else if(key.indexOf('Rewards') !== -1) {
                    activeBalances.forEach(function(item) {
                        if(item.type === 'rewards') {
                            creditExists = true;
                        }
                    });
                    if(!creditExists) {
                        addedBalance = true;
                        payment.balances.$rewards.find('input').attr('checked', 'checked');
                        payment.balances._addActiveBalance('rewards', __fixDecimals(sessionBalances[key]));
                    }
                }
                else if(key.indexOf('Gift Card') !== -1) {
                    activeBalances.forEach(function(item) {
                        if(item.type === 'giftcard') {
                            creditExists = true;
                        }
                    });
                    if(!creditExists) {
                        addedBalance = true;
                        payment.balances.$giftCards.find('input').attr('checked', 'checked');
                        payment.balances._addActiveBalance('giftcard', __fixDecimals(sessionBalances[key]));
                    }
                }
            });
        }

        if(addedBalance) {
            return;
        }

        if(oldCartTotal === 0 && currentCartTotal > 0){
            // This only happens when we arrive from a page redirect on checkout. The init total is zero, while the new total
            // has the cart items taken into consideration as well as default shipping, etc.
            // Default to a credit card to start if we didn't set a method in checkout from a redirect
            if(!payment.activeMethods.length) {
                payment.setMethodByName('creditcard');
            }
        } else if(currentCartRemaining <= fees && fees !== 0) {
            // We can only end up in this situation when store balances are active and the payment method has a fee on it.
            // In this situation, balances will cover the total without the payment fee, so the active payment method needs to be removed.
            var oldMethods = payment.activeMethods;
            payment.activeMethods = [];
            payment.currentPaymentMethod = null;
            payment._onPaymentMethodsRemoved(oldMethods);
        } else if (oldCartTotal > currentCartTotal) {
            // Balances need to be revised and the cart total updated. This happens when we end up with balances
            // taking up the whole total and removing a method with fees attached that would change the total.
            // Also possible when shipping changes.
            payment.balances.updateActiveBalances();
        } else if(currentCartRemaining === 0 && currentCartTotal !== 0){
            // Cart initializes at all values zeroed, so only react to remaining zeroing out from in store credit methods
            // (gift cards, in store credit, rewards, etc) when the cart has actually been initialized with a positive total
            // Remove the active payment methods and recompute totals
            if(payment.activeMethods.length) {
                var oldMethods = payment.activeMethods;
                payment.activeMethods = [];
                payment.currentPaymentMethod = null;

                // If we're on the payment step, reset the next step button to review
                payment._onPaymentMethodsRemoved(oldMethods);
                if(checkout.currentStepName() === 'payment') {
                    payment.setNextStepCTA(checkout.getReviewStepCTA());
                    payment.setNextStepButtonHtml(checkout.getReviewStepButtonHtml());
                }
            }

            // Only trigger the payment method area renders on the payment method step
            if(checkout.currentStepName() === 'payment') {
                // Show the no method container and message, hide the payment container
                payment._showNoMethodContainer();
            }
        } else if(currentCartTotal > oldCartTotal) {
            // If shipping changes increase the total amount, we need to update the balances with the new total.
            payment.balances.updateActiveBalances();
        } else {
            // If we have no payment methods active, one was probably
            // removed from an in store credit zeroing out the remaining value
            // or something end us up in a state with no payment method and more money to be had.
            // Default to a credit card until someone from biz decides we need to restore the previous payment method.
            // Adding the card will trigger the balance update and effectively act as a recursive call here.
            if(!payment.activeMethods.length && !payment.isMethodRemoval) {
                payment.isMethodRemoval = false;
                payment.setMethodByName('creditcard');

                var isPayPalPayment = function( p ) {
                    return p.method.indexOf( "storedbtpaypal" ) == 0;
                };

                var storedPayments = checkout.session.get( "storedPayments" ) || [];
                var storedPayPalPayments = storedPayments.filter( isPayPalPayment );
                if ( storedPayPalPayments.length == 0 ) {
                    payment.$container.find( ".js-paypal-stored" ).hide();
                } else {
                    payment.$container.find( ".js-paypal-stored" ).show();
                }

            }


            // Only trigger the payment method area renders on the payment method step
            if(checkout.currentStepName() === 'payment') {
                // Hide the no method container, show the payment container
                payment._showPaymentMethodsContainer();
            }
        }

        // Update the current payment method payment amount with remaining if we aren't using split payments
        if(payment.activeMethods.length === 1) {
            payment.activeMethods[0].payment_amount = __fixDecimals(currentCartRemaining);
        }

        // Update the review content to reflect any changes
        checkout.review.renderPaymentInfo();

        // Clear the method removal flag at the end of every total update;
        payment.isMethodRemoval = false;
    };

    this.togglePaymentMethodContainers = function(){
        var remaining = __fixDecimals(checkout.cart.totals.values.remaining);
        if(remaining === 0) {
            payment._showNoMethodContainer();
        } else {
            payment._showPaymentMethodsContainer();
        }
    };

    this._showNoMethodContainer = function() {
        payment.$noPaymentMethodContainer.find('.js-no-payment-method-msg').html(payment._getNoPaymentMethodMessage());
        payment.$noPaymentMethodContainer.show();
        payment._isNoPaymentRequired = true;
        payment.$container.hide();
    };

    this._showPaymentMethodsContainer = function() {
        payment.$noPaymentMethodContainer.find('.js-no-payment-method-msg').html('');
        payment.$noPaymentMethodContainer.hide();
        payment._isNoPaymentRequired = false;
        payment.$container.show();
    };

    // Called by methods to report that the payment is valid
    this.onMethodValid = function() {
        payment._isValid = true;
    };

    // Called by methods to report that the payment is invalid
    this.onMethodInvalid = function() {
        payment._isValid = false;
    };

    // Called by methods to set the current array of active payments
    // In store payment methods (credits, rewards, giftcards) will need to adjust
    // to the removal of fees for methods such as wire transfers, and we kick off those changes from
    // the onUpdateTotals method.
    this.setActivePaymentMethods = function(methods){
        payment.activeMethods = methods;
        checkout.cart.totals.buildPaymentMethodsV2(payment.activeMethods, payment.activeBalances);
    };

    // Called by balances to set the current in use balance methods and amounts
    // Update the totals to reflect the new card balances
    this.setActiveBalanceMethods = function(methods, isMethodRemoved){
        payment.activeBalances = methods;
        checkout.cart.totals.buildPaymentMethodsV2(payment.activeMethods, payment.activeBalances);
    };

    // Called by add card modal to add a new card to the list
    // This is a unique add, so duplicates wont make it into the array
    this.addNewCard = function(card) {
        var found = payment._addedCards.filter(function(item) {
            return item.id === card.id;
        });

        if(!found.length) {
            payment._addedCards.push(card);
        }
    };

    // Called by change card modal to get the added cards from the add card modal
    this.getAddedCards = function() {
        return payment._addedCards;
    };

    // Called by credit card if it needs to remove an added card during split payments
    this.removeAddedCard = function(id) {
        payment._addedCards = payment._addedCards.filter(function (item) {
            return item.id !== id;
        });
    };

    // Returns the message for display in the no payment method panel
    this._getNoPaymentMethodMessage = function(){
        var siteName = checkout.config.siteNameFirstWord;
        var labels = [];
        payment.activeBalances.forEach(function(item){
            switch (item.type) {
                case 'rewards':
                    labels.push(siteName + ' Rewards');
                    break;
                case 'instore':
                    labels.push(siteName + ' Store Credit');
                    break;
                case 'giftcard':
                    labels.push(siteName + ' Gift Cards balance');
                    break;
            }
        });

        return 'Your ' + labels.join(', ') + ' covers the cost of this order';
    };

    // Called by Affirm and Paypal to change the next step button text
    this.setNextStepButtonHtml = function(content) {
        checkout.$nextStep.html(content);
    };

    // Called by Affirm and Paypal to change next step button ID (CTA)
    this.setNextStepCTA = function(nextStepCTA) {
        checkout.$nextStep.attr('id', 'cta-' + nextStepCTA );
    };

    // Called by methods to set the third party redirect needed
    this.setThirdPartyPaymentActive = function(state, type){
        payment.hasThirdPartyPayment = state;
        payment.thirdPartyPaymentType = type;
    };

    // Called in checkout submit to build the session.payments array
    // Checkout process expects objects like {method: '', amount: ''}
    this.getActivePaymentMethodsForSubmit = function( callback ) {
        var data = [];
        var preparingData = 1;
        var dataPrepared = function() {
            preparingData --;
            if ( preparingData == 0 ) callback( data );
        };

        var addItem = function( payment ) {
            // This is the object the server expects for an order submit
            var store_on_account = false;
            if (checkout.session.isLoggedIn()) 
               if ( (payment.method == 'btpaypal' && !payment.paypalCredit) || payment.method == 'creditcard')
                  store_on_account = true;
            var item = {
                method: payment.method,
                amount: payment.payment_amount,
                cardType: payment.type ? payment.type : payment.cardType, // prior auth uses cardType
                cardNum: payment.card_number,
                expDate: payment.expire_date,
                cvc: payment.cvv,
                storeOnAccount:  store_on_account,
                firstname: payment.first_name,
                lastname: payment.last_name,
                address1: payment.address,
                address2: payment.address2,
                country: payment.country,
                city: payment.city,
                state: payment.state,
                zip: payment.zip,
                authNum: payment.authNum,
                amtInput: payment.amtInput,
                nonce: payment.nonce,
				paypalEmail: payment.paypalEmail,
				paypalCredit: payment.paypalCredit,
				storedPaymentID: payment.storedPaymentID,
            };
			if (item.method == 'btpaypal' && !item.nonce && item.storedPaymentID) {
				item.method = ['storedbtpaypal', item.storedPaymentID].join('-');
			}

            if(!payment.authNum) { // delete the auth num field for those that don't use it
                delete item['authNum'];
            }

            data.push(item);
        };

        var currentPaymentMethod = payment.currentPaymentMethod;
        $.each( payment.activeMethods, function( i, paymentMethod ) {
            if ( currentPaymentMethod.prepareData ) {
                preparingData ++;
                currentPaymentMethod.prepareData( paymentMethod, function() {
                    addItem( paymentMethod );
                    dataPrepared();
                } );
            }
            else {
                addItem( paymentMethod );
            }
        } );

        // we want to call the callback even if there was nothing else to do
        dataPrepared();
    };

    this.resetValidity = function() {
        var currentPaymentMethod = payment.currentPaymentMethod;
        if ( ! currentPaymentMethod.resetValidity ) return;

        $.each( payment.activeMethods, function( i, paymentMethod ) {
            currentPaymentMethod.resetValidity( paymentMethod );
        } );
    };

    // Called in checkout submit to get the bill ID of the payment
    this.getBillId = function() {
        var billId = null;
        this.activeMethods.forEach(function(item) {
            if(item.billID){
                billId = item.billID;
            }
        });
        return billId;
    };

    // Called in checkout submit to get the billing info of the payment
    this.getBillInfoForSubmit = function() {
        var billinfo = null;
        // Try and pull it out of a payment method
        this.activeMethods.forEach(function(item) {
            if(!billinfo && item.address) {
                billinfo = payment.models.getBillinfoFromPaymentMethod(item);
            }
        });

        // No billing info stored on the payment methods, grab it from session
        if(!billinfo) {
            billinfo = checkout.session.get().billing;
        }

        return billinfo;
    };

    // Called by Checkout to determine if the payment is valid
    this.isValid = function() {
        return (payment._isValid || payment._isNoPaymentRequired);
    };

    // Sets the current method by value name. Trigger the change event handler bound in _listen()
    this.setMethodByName = function(methodName) {
        payment.$container.find('input[name="payment-method"][value="'+methodName+'"]')
            .prop('checked', true)
            .trigger('change');
    };

    //Called by checkout to show the available balances section
    this.showAvailableBalances = function(){
        var inStoreBalance = parseFloat(checkout.session.get('credits.instoreBalance'));
        var rewardsBalance = parseFloat(checkout.session.get('credits.rewardBalance'));
        var giftCardBalance = parseFloat(checkout.session.get('credits.giftCardBalance'));
        if(inStoreBalance > 0 || rewardsBalance > 0 || giftCardBalance > 0){
            payment.balances.updateBalanceAvailableAmounts();
        }
        if(inStoreBalance > 0 || rewardsBalance > 0){
            payment.$balancesContainer.show();
        }
    };

    // Called by checkout to hide the available balances section
    // This should be hidden for everything but the payment tab.
    this.hideAvailableBalances = function(){
        payment.$balancesContainer.hide();
    };

    // Sets error message content and shows the container
    this.showErrors = function(content) {
        payment.$errorContainer.find('.msg-text').html(content);
        payment.$errorContainer.show();

        // Listener for if we have the paypal shipping error.
        // redirects back to shipping and open the modal
        payment.$errorContainer.find('.js-thirdparty-error-shipping').on('click', function(e) {
            e.preventDefault();
            payment.$errorContainer.hide();
            checkout.nextStep(false, 2);
        });
    };

    // Hides the errors container, does not unset messages
    this.hideErrors = function() {
        payment.$errorContainer.hide();
    };

    this.loading = function( loadingMsg ) {
        if( loadingMsg ) {
            payment.$loadingOverlay.show()
                                   .removeClass( "fade-out" )
                                   .addClass( "fade-in" );
            payment.$loadingMsg.html( loadingMsg );
        }
        else {
            payment.$loadingOverlay.removeClass( "fade-in" )
                                   .addClass( "fade-out" );
        }
    };

    this.getBT = function( callback, err_callback ) {
        callback = callback || function() { console.log("braintree client created without callback"); };
        err_callback = err_callback ||  function(e) { console.error(e) };
        if ( payment.bt ) return callback( payment.btID ++ );

        if ( ! window.braintree ) return err_callback( "Missing BT interface" );

        window.braintree.client.create({
            'authorization' : checkout.config.braintreeClientToken, 
        }).then(function(bt) {
            payment.bt = bt;
            callback( payment.btID ++ );
        }).catch(function(err) {
            err_callback( "BT client failed: " + err );
        });
    };
	
	

    this._hasStoredPayments = function() {
        return checkout.session.get('storedPayments').length ? true : false;
    };
	
    this._hasActiveStoredPayment = function() {
        return ( payment.activeMethods.length == 1 && 
                 payment.activeMethods[0].method.startsWith('storedcreditcard-') );
    }

    this._init();
};

// Javascript and fp arithmetic are like oil and water
// Takes strings or numbers, parsefloats, to fixes, and parsefloats again
// Gets everything to two digits for equality operators
function __fixDecimals(input){
    return parseFloat(parseFloat(input).toFixed(2));
}
